import React, { PureComponent } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchStep } from '../../../redux/reducers/module';
// hoc
import withSizes from 'react-sizes';
// components
import Input from '../../../components/Input/Input';
import FieldError from '../../../components/Form/FieldError';
import TextArea from '../../../components/TextArea/TextArea';
// shapes
import fixedInput from '../../../shapes/fixedInput';
// styles
import styles from './InputTable.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

const colors = ['#7fe7ab', '#ffc132', '#e05e65'];

class InputTable extends PureComponent {
  componentDidMount() {
    const { data, id, fetchStep } = this.props;
    const type = data.content.question_set_type;
    if (type === 'fixed_input_preliminary' || type === 'fixed_input_related')
      fetchStep(id);
  }

  getQuestions = () => {
    const {
      data: {
        content: { question_set_type, questions }
      }
    } = this.props;
    if (question_set_type !== 'fixed_input_related') return questions;

    return questions.filter(({ show }) => show === 't');
  };

  rendererInput = ({
    qa_type,
    preliminary_answer,
    additional_info,
    id,
    placeholder,
    view_type
  }) => {
    const { values, errors, setFieldValue } = this.props;
    const disabled = qa_type === 'example' || qa_type === 'preliminary';
    const props = {
      placeholder: placeholder || 'e.g. Something',
      value: values[id],
      invalid: errors[id],
      disabled,
      autoComplete: 'none',
      onChange: e => setFieldValue(id, e.target.value)
    };

    return view_type === 'textarea' ? (
      <TextArea className={cx('textArea')} {...props} />
    ) : (
      <Input wrapperClassName={cx('input')} {...props} />
    );
  };

  render() {
    const { isMobile, errors, isStepLoading, isDesktop, data } = this.props;
    const questions = this.getQuestions();

    if (questions.length === 0 || isStepLoading) {
      return null;
    }

    const isStressChart = data.additional_type === 'stress_chart';

    if (isDesktop) {
      return (
        <div className={cx('container')}>
          <div className={cx('row', 'head-row')}>
            <div className={cx('cell', 'cell-title')} />
            {questions[0].question_answers.map(({ title }, index) => (
              <div
                className={cx('cell')}
                style={{ color: isStressChart && colors[index] }}
                key={index}
              >
                {title}
              </div>
            ))}
          </div>

          {questions.map(question => {
            return (
              <div key={question.id} className={cx('row')}>
                <div className={cx('cell', 'cell-title')}>{question.title}</div>
                {question.question_answers.map(answer => (
                  <div className={cx('cell')} key={answer.id}>
                    {this.rendererInput(answer)}
                    <FieldError error={errors[answer.id]} touched />
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      );
    }

    if (isMobile) {
      return (
        <div className={cx('mob-container')}>
          {questions.map((question, index) => (
            <div key={index} className={cx('column')}>
              <div
                key={index}
                className={cx('cell', 'cell-header')}
                style={{ color: isStressChart && colors[index] }}
              >
                {question.title}
              </div>
              {question.question_answers.map(answer => (
                <label className={cx('mob-row')} key={answer.id}>
                  <div className={cx('cell', 'cell-title')}>{answer.title}</div>
                  <div className={cx('cell')}>
                    {this.rendererInput(answer)}
                    <FieldError error={errors[answer.id]} touched />
                  </div>
                </label>
              ))}
            </div>
          ))}
        </div>
      );
    }
  }
}

InputTable.propTypes = {
  setFieldValue: T.func.isRequired,
  fetchStep: T.func.isRequired,
  id: T.number.isRequired,
  isMobile: T.bool.isRequired,
  isDesktop: T.bool.isRequired,
  values: T.object.isRequired,
  isStepLoading: T.bool.isRequired,
  data: fixedInput
};

const enhance = compose(
  connect(
    state => ({
      isStepLoading: state.module.isLoading
    }),
    { fetchStep }
  ),
  withSizes(({ width }) => ({
    isMobile: width < 768,
    isDesktop: width >= 768
  }))
);

export default enhance(InputTable);



// WEBPACK FOOTER //
// ./src/containers/Module/components/InputTable.jsx